import { type ReactNode, Children } from 'react';
import { isElement } from 'react-is';

import { Chart } from '../slots/Chart.js';
import { Icon } from '../slots/Icon/Icon.js';
import { Label } from '../slots/Label/Label.js';
import { Legend } from '../slots/Legend.js';
import { Max } from '../slots/Max/Max.js';
import { Min } from '../slots/Min/Min.js';
import { Value } from '../slots/Value/Value.js';

/**
 * Function that selects all the meter bar layout slots from the children, and returns them identified.
 * @param children - Children for the MeterBarLayout. Should have the Label, Value, Chart and MinMaxLabel areas.
 * @returns An object with each children identified.
 */
export function extractSlots(children?: ReactNode) {
  const areas: {
    label?: ReactNode;
    min?: ReactNode;
    max?: ReactNode;
    chart?: ReactNode;
    value?: ReactNode;
    icon?: ReactNode;
    legend?: ReactNode;
  } = {};

  Children.forEach(children, (child) => {
    if (isElement(child)) {
      switch (child.type) {
        case Label:
          areas.label = child;
          break;
        case Icon:
          areas.icon = child;
          break;
        case Value:
          areas.value = child;
          break;
        case Chart:
          areas.chart = child;
          break;
        case Min:
          areas.min = child;
          break;
        case Max:
          areas.max = child;
          break;
        case Legend:
          areas.legend = child;
          break;
      }
    }
  });

  return areas;
}
